import { DeviceType } from '../model/types';

const HUAWEI_SERVICES_PATTERN = /HMSCore|HarmonyOS/;
const GOOGLE_SERVICES_PATTERN = /GMSCore/;

const USER_AGENT_DEVICE_MARKERS: readonly { marker: string; deviceType: DeviceType }[] = [
  { marker: 'iphone', deviceType: DeviceType.Ios },
  { marker: 'ipod', deviceType: DeviceType.Ios },
  { marker: 'ipad', deviceType: DeviceType.Ios },
  { marker: 'android', deviceType: DeviceType.Android },
];

function getUserAgent(): string {
  return typeof navigator === 'undefined' ? '' : navigator.userAgent ?? '';
}

export function getDeviceType(userAgent: string = getUserAgent()): DeviceType | null {
  if (HUAWEI_SERVICES_PATTERN.test(userAgent)) {
    return GOOGLE_SERVICES_PATTERN.test(userAgent) ? DeviceType.Android : DeviceType.AppGallery;
  }

  const normalizedUserAgent = userAgent.toLowerCase();

  return USER_AGENT_DEVICE_MARKERS.find(({ marker }) => normalizedUserAgent.includes(marker))?.deviceType ?? null;
}

export function isMobileDevice(userAgent?: string): boolean {
  return getDeviceType(userAgent) !== null;
}

export function isIos(userAgent?: string): boolean {
  return getDeviceType(userAgent) === DeviceType.Ios;
}

export function isAndroid(userAgent?: string): boolean {
  return getDeviceType(userAgent) === DeviceType.Android;
}

export function isAppGallery(userAgent?: string): boolean {
  return getDeviceType(userAgent) === DeviceType.AppGallery;
}
